interface Platform {
  readonly isNative: boolean;
  readonly isOfflineCapable: boolean;
}

export const platform: Platform = {
  isNative: typeof window !== 'undefined' && !!(window as unknown as { Capacitor?: unknown }).Capacitor,
  get isOfflineCapable() {
    return this.isNative;
  },
};
